import { TypeLinkAnalyticsEventWithoutUnresolvableLinksResponse } from '@/contentful-types'
import { ContentfulAnalyticsEventType } from 'src/siteBuilder/utils/types/analytics'
import { intcmpProps } from '@/hooks/useIntcmpContent'
import getParamsFromUrl from '@/siteBuilder/utils/getParamsFromUrl'
import React, { useContext, useEffect, useState } from 'react'
import { errorPageBacklinks, ErrorPageBacklink } from './errorPageBacklinks'
import { SiteBuilderContext } from '@/siteBuilder/renderer/context/SiteBuilderContext'
import ButtonLink, { ButtonLinkProps } from '../../core/ButtonLink/ButtonLink'
import { Box, Typography } from '@telus-uds/components-web'

interface KoodoErrorPageButtonProps {
  text?: string
  url?: string
  analyticsEvent?: TypeLinkAnalyticsEventWithoutUnresolvableLinksResponse
  intcmpRef?: intcmpProps
  target?: '_blank' | '_self' | '_parent' | '_top'
}

const KoodoErrorPageButton = ({
  text = '',
  url = '/',
  intcmpRef,
  target = '_self',
  analyticsEvent,
}: KoodoErrorPageButtonProps) => {
  const koodoErrorPageButtonDefaultProps: ButtonLinkProps = {
    text: text,
    url: url,
    intcmpRef: intcmpRef,
    target: target,
    analyticsEvent: analyticsEvent as unknown as ContentfulAnalyticsEventType,
    icon: undefined,
    iconPosition: 'left',
    baseModal: undefined,
    onClick: undefined,
    spacer: undefined,
    priority: 'high',
    analyticsUrlUsage: 'Standard',
    size: 'medium',
    danger: false,
    inverted: false,
    fullWidth: false,
    width: 'default',
  }

  const [buttonProps, setButtonProps] = useState(koodoErrorPageButtonDefaultProps)
  const [errorCode, setErrorCode] = useState<string | undefined>(undefined)

  const { locale } = useContext(SiteBuilderContext)

  useEffect(() => {
    const errorPageBacklinkValues = errorPageBacklinks
    const params = getParamsFromUrl()

    const errorCodeValue = params['errorCode']
    if (errorCodeValue) {
      setErrorCode(errorCodeValue)
    }

    const backlink = params['backLink']
    if (backlink) {
      const backlinkValue = errorPageBacklinkValues.find((value: ErrorPageBacklink) => value.id === backlink)
      if (backlinkValue) {
        setButtonProps({
          ...koodoErrorPageButtonDefaultProps,
          text: backlinkValue.label[locale.language],
          url: backlinkValue.link[locale.language],
        })
      }
    }
  }, [locale.language])

  return (
    <>
      {errorCode && (
        <Box bottom={3}>
          <Typography variant={{ bold: true }}>{errorCode}</Typography>
        </Box>
      )}
      <ButtonLink {...buttonProps}></ButtonLink>
    </>
  )
}

export default KoodoErrorPageButton
